import { render, staticRenderFns } from "./EditEstablishmentInternalOrderPage.vue?vue&type=template&id=56935b28"
import script from "./EditEstablishmentInternalOrderPage.vue?vue&type=script&lang=js"
export * from "./EditEstablishmentInternalOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports